/* eslint-disable */
import { FormRecordFieldView, FormRecordFieldViewFactory, } from './form-utils';
import { ComponentFactoryResolver, ComponentRef, Injector, } from '@angular/core';
import { FormRecordPhoneNumberFieldComponent } from '../../admin/form/form-record/fields/phonenumber/form-record-phonenumber-field.component';
/* eslint-enable */

export class FormRecordPhoneNumberFieldViewFactory implements FormRecordFieldViewFactory {

  constructor(
    private injector: Injector,
    private cfr: ComponentFactoryResolver) {
  }

  createView(): ComponentRef<FormRecordFieldView> {
    const cmp = this.cfr.resolveComponentFactory(FormRecordPhoneNumberFieldComponent)
      .create(this.injector);
    return cmp;
  }

}
